import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Grid, Button, Chip, TablePagination } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export const ProfilesComp = (props) => {


    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={3}>
                        <Box>
                            <Button className='grey-theme-btn' variant="outlined" startIcon={<AddIcon />} onClick={() => props.NavigateTo('profile/new')}>
                                Add New Profile
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getProfileList == false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 380 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                key={'SrNo'}
                                                align={'left'}
                                                style={{ minWidth: 70 }}
                                                className='table-head-cell'
                                            >
                                                {'SrNo'}
                                            </TableCell>
                                            <TableCell
                                                key={'Name'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Name'}
                                            </TableCell>
                                            <TableCell
                                                key={'Description'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Description'}
                                            </TableCell>


                                            <TableCell
                                                key={'Added On'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Added On'}
                                            </TableCell>
                                            <TableCell
                                                key={'Details'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {''}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.mystate.profileList != undefined && props.mystate.profileList.length > 0 ?
                                            props.mystate.profileList.map((item, i) => (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={item._id}>
                                                    <TableCell key={i + 1} align={'left'}>
                                                        {i + 1}
                                                    </TableCell>
                                                    <TableCell key={item.profile_name + i} align={'left'}>
                                                        {item.profile_name}
                                                    </TableCell>
                                                    <TableCell key={item.profile_desc + i} align={'left'}>
                                                        {item.profile_desc}
                                                    </TableCell>


                                                    <TableCell key={item.profile_created_by + i} align={'left'}>
                                                        {item.profile_created_by} <br></br> {item.profile_created_on}
                                                    </TableCell>

                                                    <TableCell key={item.profile_created_on + i} align={'left'}>
                                                        <Button><EditIcon className='grey-theme-btn' onClick={() => props.GetProfileDetails(item._id)}></EditIcon></Button>
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                            : ''
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TablePagination
                                rowsPerPageOptions={[10, 50, 100, 200, 300]}
                                component="div"
                                count={props.mystate.totalRecords}
                                rowsPerPage={props.mystate.perSet}
                                // page={props.mystate.setNo == 1 ? 1 + '-' + props.mystate.perSet : props.mystate.perSet * (props.mystate.setNo - 1) + '-' + props.mystate.perSet * (props.mystate.setNo) }
                                page={props.mystate.setNo - 1}
                                onPageChange={(e) => props.HandleChangePage(e, props.mystate.setNo - 1)}
                                //onPageChange={handleChangePage}
                                onRowsPerPageChange={(e) => props.HandleChangeRowsPerPage(e)}
                            />


                        </Paper>
                        :

                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>


            <Dialog
                open={props.mystate.alertBox}
                onClose={props.HandleCloseAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Delete User"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {'Do you want to remove ' + props.mystate.userName + ' permanently'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.HandleCloseAlert('No')}>Disagree</Button>
                    <Button onClick={() => props.HandleCloseAlert('Yes')} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>


    );
}